import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const TickCircle: FC<IconProps> = (props) => (
  <Icon {...props} title={props.title || 'Tick icon'}>
    <path
      fill="currentColor"
      d="M27 16a11 11 0 1 0-22 0 11 11 0 0 0 22 0Zm-7.81-3.58a1 1 0 0 1 1.62 1.16l-5 7a1 1 0 0 1-1.52.13l-3-3a1 1 0 1 1 1.42-1.42l2.16 2.17 4.32-6.04ZM29 16a13 13 0 1 1-26 0 13 13 0 0 1 26 0Z"
    />
  </Icon>
);
